import { Button } from './Button';
import { ADMIN_TOP_PATH, SUMMARIZED_ADMIN_ROLES } from '@/config';
import { useUserPermission } from '@/lib/auth';
import { LOGIN_PATH, PRIVATE_TOP_PATH } from '@/constants/routes';
import { useTranslation } from 'react-i18next';

type Props = {
  goToAnalyzeText?: string;
  goToAdminText?: string;
  goToLoginText?: string;
};

export const RoleBasedNavigationButtons = ({
  goToAnalyzeText,
  goToAdminText,
  goToLoginText,
}: Props) => {
  const { t } = useTranslation();
  const { data: permission } = useUserPermission();

  return (
    <>
      {permission?.summarizedRole ? (
        <>
          <Button onClick={() => (window.location.href = PRIVATE_TOP_PATH)}>
            {goToAnalyzeText || t('トップページへ')}
          </Button>
          {SUMMARIZED_ADMIN_ROLES.includes(permission.summarizedRole) && (
            <Button
              color="dark"
              onClick={() => (window.location.href = ADMIN_TOP_PATH)}
            >
              {goToAdminText || t('管理画面へ')}
            </Button>
          )}
        </>
      ) : (
        <Button
          color="dark"
          onClick={() => (window.location.href = LOGIN_PATH)}
        >
          {goToLoginText || t('ログイン画面へ')}
        </Button>
      )}
    </>
  );
};
